import { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { fetchApproved } from 'Redux/carts/actions'

const useCartsApproved = () => {
  const dispatch = useDispatch()

  const data = useSelector(state => state.carts.approved)
  const isFetching = useSelector(state => state.carts.isFetchingApproved)
  const filterProviders = useSelector(state => state.carts.filterProviders)
  const filterRequestNumber = useSelector(state => state.carts.filterRequestNumber)

  const isFilterActive = !!filterProviders?.length || !!filterRequestNumber

  useEffect(() => {
    dispatch(fetchApproved())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterProviders, filterRequestNumber])

  return { data, isFetching, isFilterActive }
}

export default useCartsApproved
